export const ATTRIBUTE_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  CURRENCY: 'currency',
  PERCENT: 'percent',
  LINK: 'link',
  DATE: 'date',
  DATETIME: 'datetime',
  LIST: 'list',
  MULTI_LIST: 'multi_list',
  CHECKBOX: 'checkbox',
};
